var map = {
	"./#03CEA4/emailEle.svg": "813f",
	"./#3777FF/emailEle.svg": "e643",
	"./#EE964B/emailEle.svg": "af90",
	"./#F754A2/emailEle.svg": "ac6c",
	"./#FF495C/emailEle.svg": "effa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "453a";